import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';

alertify.defaults = {
  // dialogs defaults
  autoReset:true,
  basic:false,
  closable:false,
  closableByDimmer:true,
  frameless:false,
  maintainFocus:true, // <== global default not per instance, applies to all dialogs
  maximizable:false,
  modal:true,
  movable:false,
  moveBounded:false,
  overflow:true,
  padding: true,
  pinnable:true,
  pinned:true,
  preventBodyShift:false, // <== global default not per instance, applies to all dialogs
  resizable:true,
  startMaximized:false,
  transition:'fade',

  // notifier defaults
  notifier:{
    // auto-dismiss wait time (in seconds)
    delay:10,
    // default position
    position:'bottom-right',
    // adds a close button to notifier messages
    closeButton: true
  },

  // language resources
  glossary:{
    // dialogs default title
    title:'',
    // ok button text
    ok: 'OK',
    // cancel button text
    cancel: 'Cancel'
  },

  // theme settings
  theme:{
    // class name attached to prompt dialog input textbox.
    input:'form-control',
    // class name attached to ok button
    ok:'btn btn-primary',
    // class name attached to cancel button
    cancel:'btn btn-danger'
  }
};

export default alertify;


// WEBPACK FOOTER //
// ./src/util/common/messages.js